import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderBanner.vue?vue&type=template&id=a27d5908&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-meal-builder-banner.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-meal-builder-banner.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorMealBuilderBanner.vue?vue&type=style&index=0&id=a27d5908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27d5908",
  null
  
)

export default component.exports